import React from "react";
import { observer } from "mobx-react-lite";
import FormLabel from "controls/formLabel";
import type CreditExposuresViewModel from "viewModels/timeCharges/distributors/creditExposures/creditExposuresViewModel";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import { translateGeneral } from "../../../../utils/localizations";
import AdvancedSelect from "@edaz/edazkit/controls/AdvancedSelect";
import { preventDefault } from "@frui.ts/views";
import Button from "@edaz/edazkit/Button/index";
import { isFilterDirty } from "../../../../utils/filters";

export interface CreditExposuresFilterProps {
  vm: CreditExposuresViewModel;
}

const CreditExposuresFilter = observer((props: CreditExposuresFilterProps) => {
  const { vm } = props;

  return (
    <Form className="mb-2" onSubmit={preventDefault(vm.applyFilterAndLoad)} onReset={preventDefault(vm.resetFilterAndLoad)}>
      <div className="row align-items-end">
        <Form.Group as={Col} md={8} lg={6} xl={4}>
          <FormLabel required={true}>{vm.translateAttribute("distributorId")}</FormLabel>
          <AdvancedSelect
            target={vm.filter}
            property="distributorId"
            items={vm.distributorOptions}
            allowEmpty={true}
            placeholder={translateGeneral("select")}
          />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={3}>
          <Form.Label>{vm.translateAttribute("state")}</Form.Label>
          <AdvancedSelect
            target={vm.filter}
            property="state"
            items={vm.stateOptions}
            allowEmpty={true}
            placeholder={translateGeneral("all")}
          />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={3}>
          <Button size="sm" className="rounded" type="submit" variant="secondary" disabled={!isFilterDirty(vm.filter)}>
            {translateGeneral("filter")}
          </Button>
        </Form.Group>
      </div>
    </Form>
  );
});

export default CreditExposuresFilter;
